import styled from "styled-components";

import { Divider } from "../../../../../../../commonStyles";
import PostAs from "./PostAs";
import PostTo from "./PostTo";

const ModalHeader = () => {
  return (
    <HeaderContainer>
      <PostAsAndToContainer>
        <PostAs />
        <Divider />
        <PostTo />
      </PostAsAndToContainer>
    </HeaderContainer>
  );
};

export default ModalHeader;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing["spacing-4"].value}rem;
  padding: ${({ theme }) => theme.spacing["spacing-4"].value}rem;
`;

const PostAsAndToContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 306px;
  width: 100%;
  gap: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
`;
